/**
 *
 * VidModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import { translate as t } from '../../utils/translator';

import Button from '../Button';

import { handleVidModal } from '../../containers/EkycPage/actions';

function VidModal(props) {
  const handleModalClose = () => {
    props.handleModalClose(false);
  };

  if (props.ekyc.vidModal) {
    return (
      <div className="explainVidPopUp">
        <div className="vidBody">
          <div className="vidHeader">
            <span className="vidHeading">{t('kyc42', props.language)}</span>
            <span className="material-icons vidClose" onClick={handleModalClose}>close</span>
          </div>
          <div className="vidDescription">
            <div className="vidDescriptionContent">{t('kyc43', props.language)}</div>
            <div className="vidDescriptionContent">{t('kyc44', props.language)}</div>
          </div>
          <Button
            text={t('kyc12', props.language)}
            onClick={handleModalClose}
          />
        </div>
      </div>
    );
  }
  return null;
}

VidModal.propTypes = {
  ekyc: PropTypes.object,
  language: PropTypes.string,
  handleModalClose: PropTypes.func,
};

const mapStateToProps = state => ({
  ekyc: state.ekyc,
  language: state.language.language,
});

function mapDispatchToProps(dispatch) {
  return {
    handleModalClose: open => dispatch(handleVidModal(open)),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(VidModal);
